import React from 'react';
import { useGetLibraryItemsQuery } from '../store/docApi';
import { Box, Card, CardContent, Typography, CircularProgress, CardMedia } from '@mui/material';
import BookIcon from '@mui/icons-material/Book';
import { Link } from 'react-router-dom';

export default function LibraryItemList() {
  // Query the getLibraryItems API with label='all'
  const { data, error, isLoading } = useGetLibraryItemsQuery({ label: 'all' });

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Typography color="error" textAlign="center" sx={{ mt: 4 }}>
        Failed to load library items: {error.message}
      </Typography>
    );
  }

  if (!data || data.length === 0) {
    return (
      <Typography textAlign="center" sx={{ mt: 4 }}>
        No library items found.
      </Typography>
    );
  }

  return (
    <Box>
      <Typography variant="h4" textAlign="center" gutterBottom>
        Library
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 3,
          justifyContent: 'center'
        }}
      >
        {data.map((item) => (
          <Box
            key={item.id}
            sx={{
              width: {
                xs: '100%',
                sm: 'calc(50% - 24px)',
                md: 'calc(33.33% - 24px)',
                lg: 'calc(25% - 24px)'
              }
            }}
          >
            <Card sx={{ height: '100%' }}>
              {item.picture ? (
                <CardMedia component="img" src={item.picture} alt={item.name || 'Library Item'} sx={{ height: 140, objectFit: 'cover' }} />
              ) : (
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: 140,
                    backgroundColor: 'lightgray'
                  }}
                >
                  <BookIcon sx={{ fontSize: 48, color: 'gray' }} />
                </Box>
              )}
              <CardContent>
                <Typography variant="h6">{item.name || 'Unnamed Item'}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {item.description || 'No description available.'}
                </Typography>
                <Link to={`/library/${item.id}`}>View Details</Link>
              </CardContent>
            </Card>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
